import { HugeiconsIcon } from "@hugeicons/react";
import {
  Call02Icon,
  ManIcon,
  Mail02Icon,
  MoreHorizontalIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { MessageContentCard } from "./MessageContentCard";
import { LiteTextEditor } from "shared/app/Editor/LiteTextEditor";

interface ManualContentProps {
  isFromContact: boolean;
  body: string;
  htmlBody?: string;
  noteType?: string;
  contactName?: string;
}

const noteTypeConfig: Record<
  string,
  { icon: typeof Call02Icon; label: string }
> = {
  Call: { icon: Call02Icon, label: "Call" },
  "Walk-in": { icon: ManIcon, label: "Walk-in" },
  Email: { icon: Mail02Icon, label: "Email" },
  Other: { icon: MoreHorizontalIcon, label: "Other" }
};

export const ManualContent = ({
  isFromContact,
  body,
  htmlBody,
  noteType = "Other",
  contactName = "Unknown"
}: ManualContentProps) => {
  const config =
    (
      noteTypeConfig as Record<
        string,
        (typeof noteTypeConfig)[string] | undefined
      >
    )[noteType] ?? noteTypeConfig.Other;

  return (
    <MessageContentCard
      isFromContact={isFromContact}
      className="flex flex-col gap-4"
    >
      <div className="divide-y divide-alpha-40">
        <div className="flex items-center gap-2 text-base font-medium text-content-1000 mb-4">
          <HugeiconsIcon
            icon={config.icon}
            size={20}
            className="text-content-1000"
          />
          <span>
            {config.label} record with {contactName}
          </span>
        </div>

        <div className="pt-4">
          {htmlBody ? (
            <LiteTextEditor
              id="manual-content-viewer"
              editable={false}
              initialValue={htmlBody}
              containerClassName="text-sm font-medium text-content-1000"
            />
          ) : (
            <p className="text-sm font-medium text-content-1000 break-words whitespace-pre-wrap">
              {body}
            </p>
          )}
        </div>
      </div>
    </MessageContentCard>
  );
};
